export const transformToFloat = (
  value: string
) => {
  return value ? +value.toString().replace(/,/g, "") : null;
};

export const transformToFormatted = (
  value: number | null | undefined,
  digits: number = 2,
  omitZero: boolean = true,
) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (omitZero && value === 0) {
    return null;
  }

  return value.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};
